module.exports = __webpack_public_path__ + "static/media/confluence-original.bae982aa.svg";